<template>
	<div class="time-selector">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="v => $emit('toggling-popup', v)">
			<div class="time-selector-body" v-if="active">
				<ModalHeader :title="getString('time')"/>
				<div class="slots">
					<div class="slot" v-for="timeslotTime in dailyTimeslots"
						 :key="timeslotTime.slot.experience_timeslot_id">
						<div class="slot-title" v-if="timeslotTime.times.length > 0">{{ timeslotTime.slot.name }}</div>
						<div class="times-container" v-if="timeslotTime.times.length > 0">
							<AppButton class="ml-auto time" outline :class="{unavailable: !time.available}" v-for="time in timeslotTime.times"
									   :key="time.time" @click="selectTime(time.time)" :text="time.time"/>
						</div>
					</div>
				</div>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppBottomSheet from '@/shared/components/AppBottomSheet.vue';
import ModalHeader from '@/console-new/components/shared/ModalHeader.vue';
import WindowWidth from '@/console-new/mixins/WindowWidth';
import {useLanguageStore} from '@/shared/stores';
import {formatDateOnly} from '@/shared/helpers/dates';
import AppButton from "@/shared/components/AppButton.vue";
import { timeslotTimes } from '@/book/helpers/availabilities';

export default {
	name: 'TimeSelector',
	components: {AppButton, AppBottomSheet, ModalHeader},
	mixins: [WindowWidth],
	emits: ['toggling-popup', 'selected-time'],
	props: {
		active: {type: Boolean, default: false},
		dailyTimeslots: {type: Array, default: () => []},
		availability: {type: Array, default: () => []},
		maxCapacity: {type: Number, default: 0},
		selectedDate: {type: Date, default: null}
	},
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return '100%';
			} else if (this.windowWidth < 768) {
				return '550px';
			} else if (this.windowWidth < 1080) {
				return '720px';
			} else if (this.windowWidth < 1440) {
				return '960px';
			} else {
				return '1280px';
			}
		}
	},
	methods: {
		selectTime(time) {
			this.$emit('selected-time', time);
			this.$emit('toggling-popup', false);
		}
	}
};
</script>

<style scoped lang="scss">
.slots {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.slot-title {
	margin-bottom: 10px;
	font-weight: 500;
}

.times-container {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;

	.time {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 60px;
		height: 32px;
		border: 1px solid var(--color-primary);
		border-radius: 13px;
		cursor: pointer;

		&.unavailable {
			opacity: 0.5;
			pointer-events: none;
		}
	}
}
</style>
